import InternalNavLink from "./InternalNavLink";

export default InternalNavLink;
